namespace SolovisGateway.Admin.DbServers {

    /**
     * AllElasticPoolListControl presents a list of all elastic pools on all of the registered database servers.
     */
    export class AllElasticPoolListControl extends Solovis.UI.BaseControl {

        private _elasticPoolList;
        private _errors;

        private _dataGrid: DevExpress.ui.dxDataGrid;


        constructor(options) {
            super(options);
        }

        public doInitAsync() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetAllElasticPools",
                { includeSizeInMB: true },
                function (response, success) {
                    if (success) {
                        self._elasticPoolList = response.result.elasticPools;
                        $(self._elasticPoolList).each(function (i, pool: any) {
                            pool.uniqueId = pool.server + "::" + pool.elasticPoolName;
                        });

                        self._errors = response.result.errors;
                    }

                    self.notifyInitComplete();
                });
        }

        public doRender() {

            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'uniqueId',
                data: this._elasticPoolList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'name'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },
                filterRow: {
                    visible: true
                },
                export: {
                    enabled: true
                },
                groupPanel: {
                    visible: true
                },
                scrolling: {
                    mode: "standard"
                },

                width: "100%",

                columns: [
                    {
                        dataField: 'elasticPoolName',
                        dataType: 'string',
                        caption: 'Elastic Pool',
                        allowSorting: true,
                        width: 300
                    },
                    {
                        dataField: 'server',
                        dataType: 'string',
                        caption: 'Server',
                        allowSorting: true,
                        width: 300
                    },
                    {
                        dataField: 'dtuLimit',
                        dataType: 'number',
                        caption: 'DTU Limit',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'storageLimitInMB',
                        dataType: 'number',
                        caption: 'Storage Limit (MB)',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'storageUsedInMB',
                        dataType: 'number',
                        caption: 'Storage Used (MB)',
                        allowSorting: true,
                        width: 200
                    }, 
                    {
                        dataField: 'storagePercentFree',
                        dataType: 'number',
                        format: 'percent',
                        caption: 'Storage Available (%)',
                        allowSorting: true,
                        width: 200
                    },
                    {
                        dataField: 'databaseCount',
                        dataType: 'number',
                        caption: 'Database Count',
                        allowSorting: true,
                        width: 200
                    }
                ]                
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }
    }

}
